export interface PaymentStoreProps {
    items: any[];
    total: any | null;
}

export interface PaymentStoreContextState {
    paymentCart: PaymentStoreProps[];

    setPaymentCart: (paymentCart: PaymentStoreProps[]) => any;
}

export const defaultPaymentStoreState: PaymentStoreContextState = {
    paymentCart: [],
    setPaymentCart: () => {},
};
